module.exports = __webpack_public_path__ + "static/img/2.d241b71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Conference/2.png
// module id = 6kr6
// module chunks = 1